import { useState } from 'react';
import { Button } from '@heroui/react';
import { Reactive, useReactor } from '@livefree/reactive';
import { CustomPin } from '@/shared/components';
import { reactive } from '@/core/reactive/reactive';

export const RemoveAuthenticatorApp = reactive.component(
  ({ services, monitors }) => {
    const [pin, setPin] = useState('');
    const [message, setMessage] = useState('');

    useReactor(services.my.removeTwoFactor, {
      success: (response, _, db) => {
        if (response.payload.success) {
          db.twofactor.clear();
        } else {
          setMessage(response.payload.message);
        }
      },
    });

    const handleRemove = () => services.my.removeTwoFactor(1, pin);

    return (
      <div className="w-full flex flex-col gap-4">
        <p className="px-1">
          To disable Two-factor authentication, enter the code from your authenticator app.
        </p>
        <CustomPin
          length={6}
          onComplete={setPin}
          isInvalid={!!message}
          errorMessage="Incorrect Security Code"
        />
        <Button
          color="danger"
          className="w-full"
          isLoading={monitors.removeTwoFactor.executing}
          isDisabled={pin.length < 6}
          onPress={handleRemove}
        >
          Disable Two-factor authentication
        </Button>
      </div>
    );
  },
  {
    name: 'RemoveAuthenticatorApp',
    monitors: services => [services.my.removeTwoFactor],
  },
);
